import React from 'react'
import moment from 'moment'
import _ from 'lodash'
import { getToken } from '../Commons/Authentication'

import * as request from 'superagent'
import NoCache from 'superagent-no-cache'

import NavigationBar from '../Commons/NavigationBar'
import TableComponent from './TableComponent'
import GraphComponent from './GraphComponent'

export default class TableData extends React.Component {
    constructor (props) {
        super (props)
        this.state = ({ data2: [], data: {medicals:[],head: [], date: [],classnames:[], cals: []}, radar: false , removed:[],checklist:[], dirty:false})
    }
    findalldata () {
      const compare = (medicals,medical,t_medical, variable) => {
        if(medicals[medical-1][variable] > t_medical[variable])
        {
          return 'icon-down'
        }
        else if(medicals[medical-1][variable] < t_medical[variable])
        {
          return 'icon-up'
        }
        else if(medicals[medical-1][variable] === t_medical[variable])
        {
          return 'icon-right'
        }
      }
      let identificacion = this.props.params.patient
      let endpoint =  `/api/v1/patient/datatable?numeroDocumento=${identificacion}`
      request
      .get(endpoint)
      .set('Authorization', `Bearer ${getToken()}`)
      .use(NoCache)
      .set('Accept', 'application/json')
      .end((err, res) => {
        if (err) {
          err
        } else {
          let data = res.body.data
          let data1 = res.body.data1
          let data2 = res.body.data2
          let dates = res.body.date
          this.setState({data:data, render:true, dates:dates, count: res.body.count, data1:data1, data2: data2,arrReserva: res.body.arrReserva})
        }
      })
    }
    clickBack (e) {
      var url = '/#/health/' + this.props.params.patient
      window.location.href = url
      console.log('e')
    }
    componentWillMount () {
      this.findalldata()
    }

    render () {

    let DATA = this.state.data
    let dates = this.state.dates
    let render = this.state.render
    let data1 = this.state.data1
    let data2 = this.state.data2
      return (

        <div>

        <NavigationBar dirty={false}/>
        <div className='back-' onClick={this.clickBack.bind(this)}>
          <div className='medical-back'>Toma de Datos 
             <a className='icon-profile'></a>
          </div>
        </div>
        {
          render ?
          <TableComponent data={DATA} theads={{count:this.state.count,names:this.state.names, dates:dates}}/>
          : <div> loading </div>
        }
        {
          render ?
          <GraphComponent data={DATA} theads={{count:this.state.count, dates:dates,data1:data1, data2:data2,arrReserva: this.state.arrReserva}}/>
          : <div> loading </div>
        }

        </div>
      )
    }

  }



// WEBPACK FOOTER //
// ./src/components/HealthTable/TableData.js